import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const AutocompleteMulti = ({
  text,
  onChange,
  options,
  textProperty,
  value,
  style,
  touched,
  setTouched,
  errorMessage,
  onBlur,
}) => {
  return (
    <div
      style={{
        display: 'grid',
        marginRight: '5px',
        marginTop: '7px',
        width: '98%',
        ...style,
      }}
    >
      <Autocomplete
        multiple
        id="checkboxes-tags-demo"
        options={options}
        value={value}
        disableCloseOnSelect
        getOptionLabel={(option) => option[textProperty]}
        isOptionEqualToValue={(option, value) => option.id === value.id} // Dodajte ovaj deo
        sx={{
          '& + .MuiAutocomplete-popper .MuiAutocomplete-option': {
            backgroundColor: '#ffff',
          },
          "& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true']":
            {
              backgroundColor: value?.length !== 0 ? '#02286029' : '#ffff',
            },
          "& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected ='true']  .Mui-focused":
            {
              backgroundColor: value?.length !== 0 ? '#02286029' : '#ffff',
            },
          // '& .Mui-focused': {
          //   backgroundColor: '#0080ff17', // Boja pozadine za fokus
          // },
        }}
        onChange={(event, value) => {
          onChange(value);
        }}
        style={style}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option[textProperty]}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={text}
            placeholder={text}
            // variant="standard"
            error={touched && value?.length === 0}
            helperText={touched && value?.length === 0 && errorMessage}
            onBlur={
              setTouched !== undefined
                ? () => setTouched(true)
                : onBlur !== undefined
                ? onBlur
                : () => {}
            }
            sx={{
              '& .MuiInput-underline:before': { borderBottomColor: '#022760' },
              '& .MuiInput-underline:after': {
                borderBottom: '1px solid #022760',
                transition: 'none',
              },
              '& .MuiInput-underline:hover:before': {
                borderBottom: '1px solid #022760 !important',
              },
              '& .MuiAutocomplete-input': {
                padding: '3px 4px 2px 5px !important',
              },
            }}
          />
        )}
      />
    </div>
  );
};

export default AutocompleteMulti;
